import { Platform, Vector2 } from '@cgs/wge';
import { ICanvasManager } from '../canvas/i_canvas_manager';
import { ICoordinateSystemInfoProvider } from '../services/coordinate_system_info_provider';
import { IScaleCalculator } from './i_scale_calculator';
import { ScaleCalculator } from './scale_calculator';

export const T_ScaleManager = Symbol('ScaleManager');

export class ScaleManager {
  popupsOffset: Vector2 = Vector2.Zero;
  private _scalers: IScaleCalculator[] = [];

  get scaler(): IScaleCalculator {
    return this._scalers[0];
  }

  constructor(
    private readonly coordinateSystemProvider: ICoordinateSystemInfoProvider,
    private readonly canvasManager: ICanvasManager,
    private readonly platform: Platform
  ) {
    this._scalers.push(new ScaleCalculator(coordinateSystemProvider, canvasManager, platform.view));

    this.platform.view.sizeChanged.listen(async () => {
      for (const scaler of this._scalers) {
        await scaler.invalidate();
      }
    });
  }

  public addScaler(canvasManager?: ICanvasManager): IScaleCalculator {
    const scaler = new ScaleCalculator(
      this.coordinateSystemProvider,
      canvasManager ?? this.canvasManager,
      this.platform.view
    );
    this._scalers.push(scaler);
    return scaler;
  }

  public removeScaler(scaler: IScaleCalculator): void {
    this._scalers = this._scalers.filter((s) => s !== scaler);
  }
}
